<template>
  <div v-if="wasSelected" class="tab-pane fade" :class="{show: selected, active: selected}" :id="'tabs-' + idTab" role="tabpanel" :aria-labelledby="'tabs-' + idTab + '-tab'">
    <slot v-if="hasSlot('content')" :name="'content'" />
    <template v-else>
      {{ content }}
    </template>
  </div>
</template>

<script>
import { v4 as uuid } from 'uuid'

export default {
  data() {
    return {
      wasSelected: false,
    }
  },
  watch: {
    selected(selectedNew, selectedOld) {
      this.wasSelected = true;
    },
  },
  mounted() {
    if(this.selected) {
      this.wasSelected = true;
    }
  },
  props: {
    idTab: {
      type: String,
      default() {
        return `${uuid()}`
      },
    },
    title: {
      type: String,
      default() {
        return `TAB`
      },
    },
    content: {
      type: String,
      default() {
        return `CONTENT`
      },
    },
    selected: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    
  },
  methods: {
    hasSlot (name = 'default') {
      return !!this.$slots[ name ];
    }
  },
}
</script>
